<template>
    <article class="upload-avatar">
        <div v-if="isProcessing" class="lc-avatar-processing upload-avatar__processing">
            <loading></loading>
        </div>
        <avatar v-else :user="user" class="avatar--large"></avatar>

        <p v-if="isProcessing" class="form__help">Your avatar is being processed</p>
        <p v-if="form.errors.has('avatar')" class="form__help form__help--error">{{ form.errors.get('avatar') }}</p>

        <form @submit.prevent="upload" action="#">
            <footer class="upload-avatar__controls">
                <template v-if="! isProcessing">
                    <input @change="change" name="avatar" id="avatar" type="file" class="lc-file-input upload-avatar__input">
                    <label for="avatar" class="button button--primary">Upload new avatar</label>
                </template>
                <a v-if="hasAvatar" @click.prevent="remove" href="#" class="lc-remove-avatar button button--outline">Remove</a>
            </footer>
        </form>
    </article>
</template>

<script>
import { mapState } from 'vuex'
import Avatar from './Avatar'
import Loading from './Loading'
import Form from '../../helpers/Form'

export default {
    data () {
        return {
            form: new Form({
                avatar: null
            }),
            currentAvatar: ''
        }
    },

    watch: {
        user (newUser, oldUser) {
            if (newUser.id) {
                this.currentAvatar = this.user.avatar_path
            }
        }
    },

    methods: {
        change (event) {
            this.form.avatar = event.target.files[0]
            this.$nextTick(() => {
                this.upload()
            })
        },

        upload () {
            this.$store.dispatch('users/uploadAvatar', this.form).then(() => {
                this.form.avatar = null
            })
        },

        remove () {
            this.$store.dispatch('users/removeAvatar').then(() => {
                this.form.finishProcessing()
            })
        },

        cancel () {
            this.form.avatar = null
        }
    },

    computed: {
        ...mapState('users', {
            user: 'current'
        }),

        isProcessing () {
            return this.user.avatar_status === 'processing'
        },

        hasAvatar () {
            return this.user.avatar_status === 'complete'
        }
    },

    components: {
        Loading,
        Avatar
    }
}
</script>
